import type { ReactNode } from 'react';

export type StudentView = 'dashboard' | 'course' | 'vocabulary' | 'homework' | 'revision' | 'progress';

interface Props {
  view: StudentView;
  onChange: (view: StudentView) => void;
}

const items: Array<[StudentView, string, string]> = [
  ['dashboard', 'Today', '⌂'],
  ['course', 'My course', '▣'],
  ['vocabulary', 'Vocabulary', 'Aa'],
  ['homework', 'Homework', '✓'],
  ['revision', 'Revision', '↻'],
  ['progress', 'Progress', '◔'],
];

export default function StudentNavigation({ view, onChange }: Props): ReactNode {
  return (
    <nav className="student-nav" aria-label="Student navigation">
      {items.map(([item, label, icon]) => (
        <button
          aria-label={label}
          aria-current={view === item ? 'page' : undefined}
          className={view === item ? 'active' : ''}
          key={item}
          onClick={() => onChange(item)}
          type="button"
        >
          <span aria-hidden="true">{icon}</span>
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
